import React from 'react';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import {
  Container,
  Typography,
  Stack,
} from '@mui/material';
import AdminAddressTable from '../sections/@dashboard/monitor/AdminAddressTable';


const StyledCard = styled('div')(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]         
      : theme.palette.background.paper, 

  padding: theme.spacing(2.5),
  borderRadius: 20,

  boxShadow:
    theme.palette.mode === 'light'
      ? '0px 0px 10px rgba(0, 0, 0, 0.15)'
      : '0px 0px 10px rgba(0, 0, 0, 0.6)',
}));


const SpaceBetweenComponents = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2.5), 
}));


export default function AdminMonitorPage() {

  return (
    <>
      <Helmet>
        <title>Manage Nodes | WatchNod UI</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h3" gutterBottom>
            Manage Nodes
          </Typography>
        </Stack>
        <StyledCard>
          <SpaceBetweenComponents />
          <AdminAddressTable />
        </StyledCard>
      </Container>
    </>
  );
}
